import { Theme } from '@mui/material';

/**
 * Maps a 0–100 score to the same semantic bands the assessment `ScorePill`
 * uses (green ≥80 / blue ≥60 / red below), so scores read consistently across
 * the dashboard and the rest of the app.
 */
export const scoreBand = (score: number, theme: Theme) => {
  if (score >= 80) {
    return { color: theme.palette.green[700], bg: theme.palette.green[200] };
  }
  if (score >= 60) {
    return { color: theme.palette.blue[700], bg: theme.palette.blue[200] };
  }
  return { color: theme.palette.red[500], bg: theme.palette.red[100] };
};

/** A domain is a "critical gap" when its maturity is well below the passing band. */
export const isCriticalGap = (score: number) => score < 50;
